import React from "react";
import formAAimg from "../../../assets/Reports/Form-AA-2024.png";
import "./FormAa.scss";

const FormAa = () => {
  return (
    <>
      <div className="form_aa">
        <div className="container">
          <div className="heading_box">Form Aa</div>
          <div className="my-5 mx-auto text-center img_container">
            <img src={formAAimg} className="img-fluid" alt="" />
          </div>
        </div>
      </div>
    </>
  );
};

export default FormAa;
